module.exports = __webpack_public_path__ + "static/media/sun.d55173e0.svg";